import React from "react";
import AnnouncementCarouselComponent from "../../carousel/AnnouncementCarouselComponent";
import MainAppBarComponent from "../../appBars/MainAppBarComponent";
import { SampleFooterComponent } from "../../footers/SampleFooterComponent";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LinkValues, RebixDAMValues } from "../../../values/strings";
import { useCoreRequestProvider } from "../../../providers/RequestProvider";

export const TermsMainPageComponent = () => {
  const [dialog, setDialog] = React.useState();
  const { t, i18n } = useTranslation();
  const coreRequest = useCoreRequestProvider();

  React.useEffect(async () => {
    if (!dialog) {
      const data = await coreRequest.get(LinkValues.core.appviews.dialogs(), {
        code: RebixDAMValues.termsOfUse,
      });
      setDialog((data.data && data.data.data) || null);
    }
  }, [dialog]);

  return (
    <div>
      <MainAppBarComponent />
      <AnnouncementCarouselComponent />
      <Container fixed>
        <Box paddingY={5}>
          <Typography variant="h5">{t("dialogRebixTermsOfUse")}</Typography>
          {(dialog && "message" in dialog && (
            <Typography variant="text">
              <div
                dangerouslySetInnerHTML={{
                  __html: dialog.message,
                }}
              />
            </Typography>
          )) || <></>}
        </Box>
      </Container>
      <SampleFooterComponent />
    </div>
  );
};
